import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

//----- store
import { fetchCardData } from "../../store/cardRunningCourses-actions";

import { makeStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./CardRunningCourses.module.css";

const useStyles = makeStyles((theme) => ({
	container: {
		maxHeight: 295,
	},
}));

const CardRunningCourses = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const history = useHistory();

	const isLoading = useSelector((state) => state.uiData.isLoading[3]);

	const cardRunningCoursesData = useSelector(
		(state) => state.cardRunningCoursesData
	);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.runningCourses;

	const iconButtonClickHandler = (item) => {
		// console.log(item.id);
		history.push("/formacao/courses/details/" + item.id);
	};

	useEffect(() => {
		dispatch(fetchCardData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("cardRunningCoursesData", cardRunningCoursesData);
	}, [cardRunningCoursesData]);

	return (
		<div className={Styles["CardRunningCourses"]}>
			<TableContainer className={classes.container}>
				<Table stickyHeader aria-label="Courses table">
					<TableHead>
						<TableRow className={Styles["MuiTableRow-head"]}>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div className={Styles["title"]}>
									Nome do Curso
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div className={Styles["title"]}>
									Data Início
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div className={Styles["title"]}>Data Fim</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{!isLoading && cardRunningCoursesData.cardData.map((row) => (
							<TableRow
								key={row.id}
								className={Styles["MuiTableBody-root"]}
							>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
									component="th"
									scope="row"
									width="220px"
								>
									<div className={Styles["subtitle"]}>
										{row.name}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.startDateStr}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.endDateStr}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										<IconButton
											aria-label="forward"
											onClick={iconButtonClickHandler.bind(
												null,
												row
											)}
										>
											<Icon>arrow_forward_ios</Icon>
										</IconButton>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
				{isLoading && (
					<div style={{ textAlign: "center" }}>
						<LoadingSpinner />
					</div>
				)}
				{cardRunningCoursesData.cardData.length == 0 && (
					<div className={Styles["no-record-found"]}>
						Não existe nenhum curso a decorrer
					</div>
				)}
			</TableContainer>
		</div>
	);
};

export default CardRunningCourses;
